/* eslint-disable no-param-reassign */
import axios from 'axios';
import {axiosMaker, errorMessage} from '../utils/utils';
import * as stageActions from './types/stages';
import store from '../store';

export const filterStages = (page, rowsPerPage, order, orderBy, searchText) => async (dispatch) => {
  if (searchText !== '' && store.getState().stages.searchText !== searchText) {
    page = 0;
  }
  if (order !== store.getState().stages.order || orderBy !== store.getState().stages.orderBy) {
    page = 0;
  }
  if (searchText === null) {
    searchText = '';
  }
  dispatch({
    type: stageActions.FILTER_STAGES_SENDING,
    payload: {
      stages: [],
      dataLength: 0,
      page,
      rowsPerPage,
      order,
      orderBy,
      searchText
    }
  });
  try {
    let filter = {};
    if (page !== null && rowsPerPage !== null && order !== null && orderBy !== null && searchText !== null) {
      filter = {
        filters: {
          name: searchText
        },
        operator: 'or',
        page,
        limit: rowsPerPage,
        sort: {
          [orderBy]: order
        }
      };
    }
    const response = await axios(axiosMaker('POST', 'stages/filter', filter, true));
    return dispatch({
      type: stageActions.FILTER_STAGES_SUCCESS,
      payload: {
        stages: response.data.results,
        dataLength: response.data.total
      }
    });
  } catch (e) {
    const error = e.response;
    
    return dispatch({
      type: stageActions.FILTER_STAGES_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const getStages = () => async (dispatch) => {
  dispatch({
    type: stageActions.GET_STAGES_SENDING,
    payload: {
      stages: [],
      dataLength: 0
    }
  });
  try {
    const data = {
      sort: {
        name: 'asc'
      },
      filters: {}
    };
    const response = await axios(axiosMaker('POST', 'stages/filter', data, true));
    return dispatch({
      type: stageActions.GET_STAGES_SUCCESS,
      payload: {
        stages: response.data.results,
        dataLength: response.data.results.length
      }
    });
  } catch (e) {
    const error = e.response;
    
    return dispatch({
      type: stageActions.GET_STAGES_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const createStage = data => async (dispatch) => {
  dispatch({
    type: stageActions.CREATE_STAGE_SENDING,
    payload: {}
  });
  try {
    await axios(axiosMaker('POST', 'stages', data, true));
    return dispatch({
      type: stageActions.CREATE_STAGE_SUCCESS,
      payload: {}
    });
  } catch (e) {
    const error = e.response;
    return dispatch({
      type: stageActions.CREATE_STAGE_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const updateStage = (id, stages) => async (dispatch) => {
  dispatch({
    type: stageActions.UPDATE_STAGE_SENDING,
    payload: {}
  });
  try {
    await axios(axiosMaker('PATCH', `stages/${id}`, stages, true));
    return dispatch({
      type: stageActions.UPDATE_STAGE_SUCCESS,
      payload: {}
    });
  } catch (e) {
    const error = e.response;
    
    return dispatch({
      type: stageActions.UPDATE_STAGE_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};
